var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_8",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 0H0V75H75V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 37.5C70.3125 55.6219 49.2188 77.3438 25.7812 65.625C7.65942 65.625 9.375 86.7188 4.6875 37.5C4.6875 19.3782 19.3782 4.6875 37.5 4.6875C55.6219 4.6875 70.3125 19.3782 70.3125 37.5Z",
    fill: "#25D366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7547 10.9034C60.3169 7.43227 56.2223 4.68047 51.7097 2.80851C47.1975 0.936548 42.3572 -0.0180976 37.4719 0.000259805C17.0016 0.000259805 0.31875 16.6784 0.3 37.1534C0.3 43.7112 2.01563 50.0911 5.25469 55.7395L0 75.0005L19.7062 69.8348C25.1554 72.8077 31.2645 74.363 37.4719 74.3583H37.4906C57.9656 74.3583 74.6438 57.6802 74.6625 37.1862C74.6667 32.3021 73.7048 27.4654 71.8317 22.9547C69.9591 18.4439 67.2169 14.3482 63.7547 10.9034ZM37.4719 68.0677C31.9368 68.063 26.5042 66.5737 21.7406 63.7552L20.6156 63.0802L8.925 66.1458L12.0469 54.7411L11.3156 53.5645C8.22098 48.6441 6.5843 42.9473 6.59531 37.1347C6.59531 20.1378 20.4563 6.27216 37.4906 6.27216C41.5488 6.26484 45.5683 7.06092 49.3172 8.61445C53.0662 10.1679 56.4708 12.4482 59.3344 15.3237C62.2073 18.1884 64.485 21.5934 66.0361 25.3424C67.5872 29.0914 68.3808 33.1102 68.3719 37.1675C68.3531 54.2255 54.4922 68.0677 37.4719 68.0677ZM54.4172 44.9393C53.4938 44.4753 48.9328 42.23 48.075 41.9112C47.2219 41.6065 46.5984 41.4472 45.9891 42.3753C45.3656 43.2987 43.5844 45.4034 43.05 46.008C42.5156 46.6315 41.9625 46.7018 41.0344 46.2425C40.1109 45.7737 37.1156 44.7987 33.5719 41.6253C30.8063 39.1643 28.9547 36.1175 28.4016 35.194C27.8672 34.2659 28.35 33.769 28.8141 33.305C29.2219 32.8925 29.7375 32.2175 30.2016 31.6831C30.6703 31.1487 30.825 30.755 31.1297 30.1362C31.4344 29.5081 31.2891 28.9737 31.0594 28.5097C30.825 28.0456 28.9734 23.4659 28.1906 21.619C27.4406 19.7956 26.6766 20.0487 26.1047 20.0253C25.5703 19.9925 24.9469 19.9925 24.3234 19.9925C23.8527 20.0044 23.3895 20.1135 22.9628 20.3127C22.5361 20.5119 22.1551 20.797 21.8437 21.1503C20.9906 22.0784 18.6047 24.3237 18.6047 28.9034C18.6047 33.4831 21.9328 37.8847 22.4016 38.5081C22.8609 39.1315 28.9359 48.502 38.2594 52.5333C40.4625 53.4942 42.1969 54.0614 43.5516 54.4927C45.7781 55.2052 47.7891 55.0973 49.3922 54.8677C51.1734 54.5958 54.8813 52.6177 55.6641 50.4473C56.4328 48.2723 56.4328 46.4159 56.1984 46.0268C55.9688 45.6331 55.3453 45.4034 54.4172 44.9393Z",
    fill: "#F5F5F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappFill);
export default __webpack_public_path__ + "static/media/whatsapp-fill.7ec3ae2f382beebb45fb129c82e6cd64.svg";
export { ForwardRef as ReactComponent };